/**
 * W1 戰場可讀性常數(GAME_OVERHAUL_PLAN §2 W1「戰場可讀性包」)。
 *
 * 體檢根因 #6:背景白星(烘在 h-stage PNG 裡)亮度與子彈/敵人打平、玩家最不
 * 顯眼、傷害數字 18px 手機 FIT 縮放後 ~9px 看不見。
 * 視覺優先級鐵則:玩家 > 敵彈 > 敵人 > 拾取 > 背景。
 *
 * 所有 W1 可讀性手感數值集中在這裡(體檢病灶 #4:不再撒魔術數字)。
 * feedback-presets.json 是 juice(shake/flash/particles)schema,字級/tint
 * 放不進去,故獨立成這個常數模組;W2-3 的 balance/feel.json 落地後可整批搬。
 *
 * 手機等效字級換算:GAME 800px 寬 FIT 進 ~390-412px 手機 → 縮放 ~0.49-0.52,
 * 「等效 px」≈ 原始 px × 0.5。HUD 頂部文字要 ≥12px 等效 → 原始 ≥24px。
 */

/** 傷害數字 — 字級加倍 + 深色描邊 + 出現時 scale pop(1.3 → 1.0)。 */
export const DAMAGE_NUMBER_STYLE = {
  /** 一般傷害字級(was 18px → ~9px 等效看不見;36px → ~18px 等效)。 */
  fontPxNormal: 36,
  /** 門派剋制(affinity = 本作的爆擊概念)— 更大。 */
  fontPxAffinity: 44,
  /** 大傷害(amount ≥ bigDamageMin)— 更大更黃。 */
  fontPxBig: 44,
  /** 玩家基礎彈傷 10 → 3 倍以上視為「大傷害」。 */
  bigDamageMin: 30,
  /** 大傷害金黃(跟 HUD 金色一致)。 */
  bigDamageColor: '#ffd54f',
  /** 深紫黑描邊 — 疊在亮星空背景上仍可讀。 */
  strokeColor: '#1a1023',
  strokePx: 5,
  /** 出現時 scale 1.3 → 1.0 的 pop。 */
  popScaleFrom: 1.3,
  popMs: 120,
} as const;

/**
 * 背景降噪 — 星星/高光烘在 h-stage PNG 裡(且 PNG 被 .gitignore,改圖不可
 * 版控),所以用乘法 tint 把整層 tileSprite 壓暗:白星 0xff → ~0x6b(亮度
 * -58%),整層退回「背景」,絕不再與子彈/敵人打平。
 */
export const BACKGROUND_READABILITY = {
  /** stageBg tileSprite 乘色(帶一點藍紫,不變灰)。 */
  dimTint: 0x6b6b80,
} as const;

/** 玩家戰車底光 — 柔和淺色雙層 ellipse,讓主角第一眼可辨。 */
export const PLAYER_GLOW = {
  /** 外圈暖白 halo。 */
  color: 0xfff3c4,
  alpha: 0.22,
  widthPx: 110,
  heightPx: 64,
  /** 內圈更小更亮。 */
  innerColor: 0xffffff,
  innerAlpha: 0.16,
  innerWidthPx: 72,
  innerHeightPx: 42,
  /** 蓋在背景(-10)與敵人(0)之上、玩家本體(1)之下。 */
  depth: 0.9,
} as const;

/** HUD 文字 — 手機縮放(×~0.5)後 ≥12px 等效。 */
export const HUD_TEXT = {
  /** 頂部(金幣/波次/戰力槽 label):26px → ~13px 等效。 */
  fontPxTop: 26,
  /** 戰力槽 label(置中上方,空間較擠):24px → ~12px 等效。 */
  fontPxPowerLabel: 24,
  /** 底部 HP 數字(夾在血條與經驗條之間):20px。 */
  fontPxHp: 20,
  strokeColor: '#0a0c12',
  strokePx: 4,
} as const;
